import { CSSObject, styled, Tab, Theme } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import React from 'react';

import { ENVIRONMENT } from '@/constants';
import { useTranslator } from '@/hooks/useTranslator';
import { FiatAccountDetails } from '@/Screens/Dashboard/Home/FiatAccountDetails';
import { WalletDetails } from '@/Screens/Dashboard/Home/WalletDetails';
import { CurrencyCodeType, PaymentRailType } from '@/types/currency';

export const DigitalDollarDetails: React.FC = (): React.ReactElement => {
  const [currentTab, setCurrentTab] = React.useState<number>(0);

  const tr = useTranslator();
  const onTabChange = React.useCallback((_: React.SyntheticEvent, value: number): void => {
    setCurrentTab(value);
  }, []);

  const tabs = React.useMemo((): readonly React.ReactElement[] => {
    return [
      <FiatAccountDetails key={PaymentRailType.ACH} paymentRail={PaymentRailType.ACH} />,
      <FiatAccountDetails key={PaymentRailType.Swift} paymentRail={PaymentRailType.Swift} />,
      <WalletDetails key={CurrencyCodeType.USDC} currency={CurrencyCodeType.USDC} />,
    ];
  }, []);

  return (
    <>
      <Tabs value={currentTab} slotProps={tabsSlotProps} variant="fullWidth" onChange={onTabChange}>
        <StyledTab value={0} label={tr('USD_FOR_DOMESTIC_ACH_AND_WIRES_ONLY')} />
        <StyledTab value={1} label={tr('SWIFT')} />
        {ENVIRONMENT === 'develop' ? <StyledTab value={2} label="USDC" /> : null}
      </Tabs>
      {tabs[currentTab]}
    </>
  );
};

const tabsSlotProps = { indicator: { sx: { backgroundColor: 'text.primary' } } };

const StyledTab = styled(Tab)(
  ({ theme }: { theme: Theme }): CSSObject => ({
    '&:first-of-type': {
      paddingRight: 0,
      paddingLeft: 0,
      minWidth: 320,
      flexShrink: 0,
    },
    '&.Mui-selected': {
      color: theme.palette.text.primary,
    },
  }),
);
